import contractions from './contractions.js'

export default { one: { contractions } }
